document.addEventListener('DOMContentLoaded', () => {
    const menu_init = () => {
        const header = document.querySelector('header');
        if (!header) return;

        const menu = header.querySelector('.header__menu');
        if (!menu) return;

        const buttons = header.querySelectorAll('.menu_button_image');
        const links = header.querySelectorAll('.header__menu a');

        // メニューの開閉トグル
        const toggleMenu = () => menu.classList.toggle('is-active');
        const closeMenu = () => menu.classList.remove('is-active');

        // ボタンにトグルを設定
        buttons.forEach(btn => btn.addEventListener('click', toggleMenu));

        // リンククリック時にメニューを閉じる
        links.forEach(link => link.addEventListener('click', closeMenu));
    };

    menu_init();
});
